__turbopack_context__.v({
  "className": "pZQ8eW_className",
});
